const pageColumn = document.getElementById('pageColumn');

// 対象ページでのみ実行
if (pageColumn) {
    const tabs = document.querySelectorAll(".area__item"); // カテゴリタブ
    const items = document.querySelectorAll(".columnList__item"); // 記事リスト
    const titleImages = document.querySelectorAll(".titleImage"); // タイトル画像
    const articleCount = document.querySelectorAll(".article-count"); // 記事数表示エリア

    // ===== 共通関数：タブの選択状態をリセットする =====
    function clearActiveTabs() {
        tabs.forEach((tab) => tab.classList.remove("is-active"));
    }

    // ===== 共通関数：指定したカテゴリに応じて表示を切り替える =====
    function activateCategory(category) {
        // タブをアクティブに
        clearActiveTabs();
        const targetTab = Array.from(tabs).find(
            (tab) => tab.dataset.category === category
        );
        if (targetTab) {
            targetTab.classList.add("is-active");
        }

        // 記事リストをフィルタリング
        items.forEach((item) => {
            item.classList.toggle("is-active", item.dataset.category === category);
        });

        // タイトル画像をフィルタリング
        titleImages.forEach((image) => {
            image.classList.toggle(
                "is-active",
                image.dataset.category === category
            );
        });

        // 記事数をフィルタリング
        articleCount.forEach((count) => {
            count.classList.toggle(
                "is-active",
                count.dataset.category === category
            );
        });
    }

    // ===== 初期表示処理：URLパラメータに合わせてセットする =====
    function setDefaultCategoryFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const paramCategory = urlParams.get("category");

        if (paramCategory) {
            activateCategory(paramCategory);
        } else if (tabs.length) {
            // パラメータがない場合は最初のカテゴリを表示
            activateCategory(tabs[0].dataset.category);
        }
    }

    // ===== タブをクリックしたときの処理 =====
    function setupTabClickEvents() {
        tabs.forEach((tab) => {
            tab.addEventListener("click", (e) => {
                e.preventDefault();
                activateCategory(tab.dataset.category);

                // 履歴を作成する
                const url = new URL(location.origin + location.pathname);
                url.searchParams.set("category", tab.dataset.category);
                history.pushState({}, "", url);
            });
        });
    }

    // ===== ページ読み込み時に実行する =====
    if (tabs.length) {
        setDefaultCategoryFromUrl();
        setupTabClickEvents();
    }
}